import React from "react";
import { Actions } from "../components/buttons/Actions";
import { CreateDrawer } from "../components/drawer/DrawerComponent";
import { GenericSwitch } from "../components/elements/Switch";
import {
  actionsColumn,
  activeColumn,
  createdColumn,
} from "../constants/objects";
import { sAddRegion, sUGX } from "../constants/strings";
import { useAppContext } from "../context/useAppContext";
import { RegionForm } from "../forms/RegionForm";
import { dateTimeFormat, numberFormatter } from "../utils/formatter";
import { DeleteData } from "./firebase/useFirebase";

export const useRegion = () => {
  const { contextData } = useAppContext();

  const tableData = (data) => [
    ...data.map((item) => {
      const row = {
        timestamp: dateTimeFormat(item?.timestamp),
        region_name: item.region_name,
        cost: numberFormatter(item.cost),
        active: (
          <GenericSwitch end checked={item.active} docRef={item.docRef} />
        ),
        actions: (
          <Actions
            actions={[
              // { action: "Edit" },
              {
                action: "Delete",
                click: () => DeleteData(item.docRef),
                confirm: true,
              },
            ]}
          />
        ),
        onclick: () =>
          contextData.showGlobalDrawer({
            component: <RegionForm data={item} />,
            title: "Update Region",
          }),
      };
      return row;
    }),
  ];

  const tableColumns = () => [
    { id: "region_name", title: "Region Name", align: "left" },
    {
      id: "cost",
      tag: sUGX,
    },
    createdColumn,
    activeColumn,
    actionsColumn,
  ];

  return {
    tableColumns,
    tableData,
    header: () => {
      return <CreateDrawer title={sAddRegion} form={<RegionForm />} />;
    },
  };
};
